module.exports = __webpack_public_path__ + "static/media/comment.a7281bb6.png";